// src/utils/tradeIdFormatter.js

/**
 * Returns a clean sequential Trade ID like GJ-000001, GJ-000002...
 * Ensures random MongoDB ObjectIDs are never shown to users or admins.
 */
export const formatTradeId = (trade, index = 0, totalListCount = 0) => {
  if (trade && trade.tradeId && /^GJ-\d+$/.test(trade.tradeId)) {
    return trade.tradeId;
  }

  if (totalListCount > 0) {
    const seq = Math.max(1, totalListCount - index);
    return `GJ-${String(seq).padStart(6, "0")}`;
  }

  return trade?.tradeId || "";
};
